import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["location"];
import * as React from 'react';
import { isUndefined, isObject } from 'lodash-es';
import { Enum, isElementOfType, isDefined, removeUndefined } from '../../../../library';
import { MapRatioType } from '../../interactive';
import { StaticMarker } from './static-marker';
export var MapFormatType = Enum({
  JPG: 'jpg',
  PNG: 'png',
  GIF: 'gif'
});
export var MapType = Enum({
  HYBRID: 'hybrid',
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  TERRAIN: 'terrain'
});
export var StaticMap = function StaticMap(props) {
  var _props$height, _React$Children$map;
  var width = isDefined(props.width) ? props.width : isDefined(props.height) ? Math.round(props.height / getMapRatio(props.ratio)) : 460;
  var height = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : Math.round(width * getMapRatio(props.ratio));
  var markers = (_React$Children$map = React.Children.map(props.children, function (child) {
    if (React.isValidElement(child) && isElementOfType(child, StaticMarker)) {
      var _child$props = child.props,
        location = _child$props.location,
        styles = _objectWithoutProperties(_child$props, _excluded);
      var formattedLocation = _typeof(location) === 'object' ? "".concat(location.lat, ",").concat(location.lng) : encodeURIComponent(location);
      var formattedStyles = Object.keys(styles).map(function (key) {
        return "".concat(key, ":").concat(encodeURIComponent(styles[key]));
      }).join('|');
      return "markers=".concat(formattedStyles).concat(formattedStyles.length > 0 ? '|' : '').concat(formattedLocation);
    }
    return undefined;
  })) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.filter(isDefined).join('&');
  var parameters = removeUndefined({
    center: isDefined(props.center) ? isObject(props.center) ? "".concat(props.center.lat, ",").concat(props.center.lng) : props.center : undefined,
    zoom: props.zoom,
    size: "".concat(width, "x").concat(height),
    scale: props.scale,
    maptype: props.mapType,
    format: props.format,
    key: props.apiKey
  });
  if (isUndefined(parameters.center) && (isUndefined(markers) || markers.length === 0)) {
    console.warn('You must provide the center property or have at least one marker child');
    return null;
  }
  var src = "http://maps.googleapis.com/maps/api/staticmap?".concat(objectToParams(parameters));
  if (isDefined(markers) && markers.length > 0) {
    src += "&".concat(markers);
  }
  return React.createElement("img", {
    alt: props.altText,
    className: props.className,
    src: src,
    style: props.style
  });
};
StaticMap.Marker = StaticMarker;
StaticMap.defaultProps = {
  ratio: MapRatioType.STANDARD,
  scale: 2,
  mapType: MapType.ROADMAP
};
function getMapRatio(ratioType) {
  switch (ratioType) {
    case MapRatioType.SQUARE:
      return 1;
    case MapRatioType.STANDARD:
      return .75;
    case MapRatioType.WIDESCREEN:
      return .625;
    case MapRatioType.UTRAWIDE:
      return .5;
  }
  throw new Error('Invalid Ratio Type');
}
function objectToParams(obj) {
  return Object.keys(obj).map(function (key) {
    var value = obj[key];
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      return "".concat(key, "=").concat(encodeURIComponent(value));
    }
    return undefined;
  }).filter(function (o) {
    return o !== undefined;
  }).join('&');
}